export default __webpack_public_path__ + "static/media/level-8-bg.0239c0d5.png";